export default "__VITE_ASSET__BYLEjPN7__"